export { default } from './BlogSlider';
